import {
  CacheableMethod,
  LoginService,
  SrsSelectOption,
  State,
} from "@edtell-common";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { apiURL } from "src/environments/environment";
import { Plc } from "../../modules/customer/interfaces/plc.interface";
import { Timezone } from "../../modules/customer/interfaces/timezone.interface";
import { Vec } from "../../modules/customer/interfaces/vec.interface";
import { Country } from "src/app/modules/edtell-common/edtell-portal/interfaces/country.interface";
import { Observable } from "rxjs";
import { UpdateActiveTimezonesRequest } from "../../modules/admin/interfaces/update-active-timezones-request.interface";

@Injectable({
  providedIn: "root",
})
export class CommonService {
  private httpOptions: unknown;
  private textHttpOptions: unknown;

  constructor(
    private http: HttpClient,
    private loginService: LoginService,
  ) {
    this.httpOptions = loginService.httpOptions;
    this.textHttpOptions = loginService.textHttpOptions;
  }

  @CacheableMethod({ copy: true })
  getStates() {
    return this.http.get<State[]>(
      `${apiURL}/common-app/common/states/all`,
      this.httpOptions,
    );
  }

  @CacheableMethod({ copy: true })
  getActiveStates() {
    return this.http.get<State[]>(
      `${apiURL}/common-app/common/states/active`,
      this.httpOptions,
    );
  }

  getTimezones() {
    return this.http.get<Timezone[]>(
      `${apiURL}/common-app/common/timezones`,
      this.httpOptions,
    );
  }

  getPlcs() {
    return this.http.get<Plc[]>(
      `${apiURL}/common-app/common/plcs`,
      this.httpOptions,
    );
  }

  getVecs() {
    return this.http.get<Vec[]>(
      `${apiURL}/common-app/common/vecs`,
      this.httpOptions,
    );
  }

  @CacheableMethod()
  getCountries() {
    return this.http.get<Country[]>(
      `${apiURL}/common-app/common/countries`,
      this.httpOptions,
    );
  }

  getWars() {
    return this.http.get<string[]>(
      `${apiURL}/common-app/common/wars`,
      this.httpOptions,
    );
  }

  getDefaultStateOptions(): Observable<SrsSelectOption<string>[]> {
    return new Observable((obs) => {
      this.getStates().subscribe((states) => {
        const options: SrsSelectOption<string>[] = [];
        for (const state of states) {
          options.push({
            text: state.stateCode,
            value: state.stateCode,
          });
        }

        obs.next(options);
      });
    });
  }

  getActiveStateOptions(): Observable<SrsSelectOption<string>[]> {
    return new Observable((obs) => {
      this.getActiveStates().subscribe((states) => {
        let options: SrsSelectOption<string>[] = [];
        const InUSOption: SrsSelectOption<string>[] = [];
        const OutsideUSOption: SrsSelectOption<string>[] = [];
        for (const state of states) {
          if (state.countryCode == "USA") {
            InUSOption.push({
              text: state.stateCode,
              value: state.stateCode,
            });
          } else {
            OutsideUSOption.push({
              text: state.stateCode,
              value: state.stateCode,
            });
          }
        }
        options = InUSOption.concat(OutsideUSOption);
        obs.next(options);
      });
    });
  }

  getDefaultCountryOptions(): Observable<SrsSelectOption<string>[]> {
    return new Observable((obs) => {
      this.getCountries().subscribe((countries) => {
        let options: SrsSelectOption<string>[] = [];
        for (const country of countries) {
          if (country.country_code == "USA" || country.country_code == "CAN") {
            continue;
          }
          options.push({
            text: country.country_name,
            value: country.country_code,
          });
        }

        const usCaOptions: SrsSelectOption<string>[] = [
          {
            text: "United States",
            value: "USA",
          },
          {
            text: "Canada",
            value: "CAN",
          },
        ];

        options = [...usCaOptions, ...options];

        obs.next(options);
      });
    });
  }

  updateActiveTimezones(req: UpdateActiveTimezonesRequest) {
    return this.http.put<Timezone[]>(
      `${apiURL}/common-app/common/timezones/active`,
      req,
      this.httpOptions,
    );
  }
}
